export { default as CoreNotificationsMenu } from './Menu';
